export default "__VITE_ASSET__EXAxJf3t__"